var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"navigation-btn btn btn--bubble",class:_vm.rootClasses},_vm.$listeners),[_c('span',{staticClass:"navigation-btn__root"},_vm._l((3),function(n){return _c('span',{key:n,staticClass:"navigation-btn__bar"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }